<img
    alt=""
    class="my-20 ml-10 w-44 shrink-0"
    [src]="currentTheme().mode | appLogo"
/>
